// removed by extract-text-webpack-plugin
module.exports = {"values":"DropdownTheme__values___2tw9J"};


//////////////////
// WEBPACK FOOTER
// ./src/shared-styles/DropdownTheme.css
// module id = 327
// module chunks = 0